export default __webpack_public_path__ + "static/media/gallery_05.e7432cf5.jpg";